import { toast } from 'react-toastify';
import { ReactComponent as IconClose } from '../../../assets/shared/ic-shared-close.svg';
import { ReactComponent as IconVMark } from '../../../assets/shared/ic-shared-checkmark-circle.svg';
import { Heading } from '../../tokens';

export const LiliToastDefaultConfig = {
  autoClose: 3000,
  closeOnClick: false,
  closeButton: false,
  hideProgressBar: true,
  draggable: false,
  position: 'top-center' as const,
};

export interface LiliToastProps {
  text: string;
  showCloseButton?: boolean;
  id: string;
  closeToast?: () => void;
}

export const LiliToast = (props: LiliToastProps) => {
  const { text, showCloseButton, id } = props;

  return (
    <div
      className='bg-surface-primary-bw-08 items-center flex px-[14px] py-[10px] h-[44px] min-h-[44px] rounded-md justify-between'
      id={id}>
      <div className='flex items-center'>
        <IconVMark className='w-[20px] h-[20px] mr-[8px] text-text-main-primary-inverse' />
        <Heading.H9 className='text-text-main-primary-inverse'>{text}</Heading.H9>
      </div>
      {showCloseButton && (
        <IconClose
          className='w-[20px] h-[20px] ml-[8px] text-text-main-primary-inverse cursor-pointer'
          onClick={() => toast.dismiss()}
        />
      )}
    </div>
  );
};
